import request from '@/utils/request'
import setting from '@/settings'
import qs from 'qs'
const apiUrl = setting.apiUrl

/**
 * 获取用户系统权限
 * @param data
 */
export const getRightByUserId = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/login/getRightInfo`, // '/jida/base/user/right/list',
    method: 'post',
    data: qs.stringify(data)
  })

/**
 * 获取用户操作权限，作废
 * @param data
 */
export const getOperaRight = (data: any) =>
  request({
    url: `${apiUrl.api}/lb/right/getOperaRight`,
    method: 'post',
    data: qs.stringify(data)
  })
